import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionDisagreeIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#676767" height="28" rx="14" width="28" />
    <path
      clipRule="evenodd"
      d="M14 3.5C8.201 3.5 3.5 8.201 3.5 14C3.5 19.799 8.201 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.201 19.799 3.5 14 3.5Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17 13.75C16.172 13.75 15.5 12.8548 15.5 11.75C15.5 10.646 16.172 9.75 17 9.75C17.8286 9.75 18.5 10.646 18.5 11.75C18.5 12.8548 17.8286 13.75 17 13.75Z"
      fill="#676767"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9 12.5C8.172 12.5 7.5 11.6048 7.5 10.5C7.5 9.396 8.172 8.5 9 8.5C9.8286 8.5 10.5 9.396 10.5 10.5C10.5 11.6048 9.8286 12.5 9 12.5Z"
      fill="#676767"
      fillRule="evenodd"
    />
    <path
      d="M11.3554 6.1232C11.7085 6.33908 11.8183 6.79951 11.6012 7.15193C11.3838 7.50452 10.921 7.61557 10.5674 7.39973C9.42631 6.7031 8.41348 6.9159 7.59968 7.09084L7.52365 7.1034C7.14508 7.14557 6.78842 6.89617 6.70709 6.51735C6.62035 6.11326 6.87964 5.71478 7.28549 5.62753L7.63128 5.55552C8.51041 5.38145 9.88006 5.22241 11.3554 6.1232Z"
      fill="#676767"
    />
    <path
      d="M15.8397 7.32657C15.4901 7.54847 15.3878 8.01122 15.6111 8.35991C15.8347 8.70865 16.2994 8.81161 16.6491 8.58964C17.7778 7.87319 18.7943 8.06828 19.6111 8.22907C20.0184 8.30925 20.4138 8.04566 20.4935 7.64013C20.5732 7.23464 20.307 6.84074 19.8997 6.76056C19.0609 6.59546 17.5074 6.26815 15.8397 7.32657Z"
      fill="#676767"
    />
    <path
      d="M14.9432 16.8736C14.7782 17.2253 14.3756 17.3891 14.0168 17.2635L13.9458 17.2347L13.497 17.032C11.3181 16.0851 10.086 16.1038 9.35635 16.0922L9.27932 16.0874C8.90195 16.0429 8.61205 15.7191 8.61843 15.331C8.62537 14.9168 8.96716 14.586 9.38135 14.5926L9.75124 14.6003C10.6264 14.6246 11.9894 14.7428 14.0859 15.652L14.5828 15.8767L14.6502 15.9129C14.9764 16.108 15.1081 16.5219 14.9432 16.8736Z"
      fill="#676767"
    />
    <path
      d="M6.34487 15.9106C6.77944 15.8304 7.22898 15.9251 7.59405 16.1747C7.95914 16.4245 8.20993 16.8094 8.29085 17.2438L8.62543 19.0401L15.6063 17.7527C16.0409 17.6725 16.4905 17.7672 16.8555 18.0168C17.2204 18.2666 17.4712 18.6507 17.5521 19.085C17.633 19.5193 17.5372 19.9673 17.2865 20.3306C17.0356 20.6938 16.6502 20.9434 16.2156 21.0236L13.8329 21.463L14.1675 23.2592C14.2765 23.8451 14.1476 24.4497 13.8091 24.94C13.4704 25.4303 12.95 25.7667 12.363 25.875L10.063 26.2992C9.17134 26.4625 8.25013 26.2671 7.50216 25.7556C6.75434 25.244 6.24046 24.4578 6.07374 23.5692L5.00831 17.8492C4.9274 17.4148 5.02292 16.966 5.2738 16.6026C5.52469 16.2394 5.91032 15.9907 6.34487 15.9106Z"
      stroke="white"
    />
    <path
      d="M15.6978 18.2438L8.2253 19.6218L7.79916 17.334C7.74265 17.0306 7.56734 16.762 7.31179 16.5873C7.05623 16.4125 6.74138 16.3459 6.43648 16.4021C6.13158 16.4584 5.86162 16.6328 5.68599 16.8871C5.51035 17.1414 5.44342 17.4547 5.49993 17.758L6.56528 23.4776C6.70741 24.2356 7.14589 24.9065 7.78454 25.3433C8.42319 25.78 9.20985 25.9469 9.97199 25.8073L12.2712 25.3833C12.7286 25.2989 13.1335 25.0373 13.397 24.6558C13.6604 24.2744 13.7608 23.8045 13.676 23.3494L13.2499 21.0616L16.1239 20.5316C16.4288 20.4753 16.6988 20.3009 16.8744 20.0466C17.0501 19.7923 17.117 19.479 17.0605 19.1757C17.004 18.8723 16.8287 18.6037 16.5731 18.4289C16.3176 18.2541 16.0027 18.1875 15.6978 18.2438Z"
      fill="#676767"
    />
  </svg>
);
